import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { BarTooltipProps, ResponsiveBar } from '@nivo/bar';
import { PropsWithChildren } from 'react';

import { BarData } from '../types';

import { useSxStyles } from './useStyles';

type Props = {
  data: BarData[];
  title: string;
};

export const BarChart: React.FC<Props> = ({ data, title }) => {
  const sxStyles = useSxStyles();
  const ColorBox = ({ label, color }: { label: string; color: string }) => {
    const colorBoxStyle = {
      background: `${color}`,
      height: '18px',
      marginRight: '8px',
      minWidth: '18px',
      width: '18px',
    };

    return (
      <Grid item sx={sxStyles.colorBox}>
        <span style={colorBoxStyle} /> {label}
      </Grid>
    );
  };

  const getCustomTooltip = (
    d: PropsWithChildren<BarTooltipProps<BarData>>,
    _e: React.MouseEvent<HTMLCanvasElement>,
  ) => {
    return <ColorBox label={`${d.data.label}: ${d.value}`} color={d.color} />;
  };

  const reversedData = [...data].reverse();

  return (
    <Card sx={sxStyles.chartCard}>
      <CardHeader
        sx={sxStyles.chartHeader}
        title={title}
        titleTypographyProps={sxStyles.chartCardTitle}
      />
      <CardContent sx={sxStyles.chartCardContent}>
        <Grid container sx={sxStyles.barChartContainer}>
          <ResponsiveBar
            data={reversedData}
            keys={['value']}
            indexBy="label"
            margin={{
              top: 0,
              right: 150,
              bottom: 0,
              left: 0,
            }}
            reverse={true}
            padding={0.05}
            innerPadding={2}
            groupMode="grouped"
            layout="horizontal"
            colors={data && data[0] ? data[0]['color'] : undefined}
            colorBy={'id'}
            axisTop={null}
            axisRight={{
              tickSize: 0,
              tickPadding: 5,
              tickRotation: 0,
              legend: '',
              legendOffset: 10,
            }}
            axisBottom={null}
            axisLeft={null}
            enableGridY={false}
            labelTextColor="#000"
            animate={true}
            tooltip={(d, e) => getCustomTooltip(d, e)}
            legends={[]}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};
